import $get from 'lodash.get'

export default {
  beforeRouteUpdate(to, from, next) {
    if (this.$voicer.isMobileOrTablet) {
      // nothing to see here now
    }
    next()
  },
  beforeRouteLeave(to, from, next) {
    // a media is playing & user wanna move from listen-page to index
    const mediaIsPlaying =
      this.$store.getters['player/isLoading'] ||
      this.$store.getters['player/isPlaying']
    if (
      mediaIsPlaying &&
      $get(from, 'name') === 'listen-content' &&
      $get(to, 'name') !== 'listen-content'
    ) {
      this.$store.dispatch('player/openPersistantPlayer')

      // fixme:
      // create a "detacheable" block where the video is played
      // so we can remove this
      const episode = this.$store.getters['player/currentEpisode']
      const item = this.$spoke.item(episode)

      // if the currently played media is a video
      // we unload the episode (stopped)
      // could be fixed via a detechable video feature
      if (item && item.isVideo === true) {
        item.unload()
      }
    }
    next()
  },
}
